import { Injectable } from '@angular/core';
import { SMProductBasic } from 'src/app/models/SMProductBasic';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MyCartFlowService {

  private products = new BehaviorSubject(null);
  oproducts: Observable< {product: SMProductBasic, count: number}[] > = this.products.asObservable();
  private currentBrandID: string;
  private count = new BehaviorSubject(0);
  ocount: Observable<number> = this.count.asObservable();

  constructor() { }

  addOrUpdateProduct(product: {product: SMProductBasic, count: number}, brandID: string): Promise<string> {
    if (this.products.value && this.currentBrandID === brandID) {
      const next = this.products.value;
      let isProductFound = false;
      next.forEach(element => {
        if (element.product.productID === product.product.productID) {
          element.count = product.count;
          isProductFound = true;
        }
      });
      if (!isProductFound) {
        next.push(product);
      }
      this.products.next(next);
      this.updateCount();
      return Promise.resolve('success');
    } else if (!this.products.value || this.products.value.length === 0) {
      const next = [];
      next.push(product);
      this.products.next(next);
      this.currentBrandID = brandID;
      this.updateCount();
      return Promise.resolve('success');
    } else {
      return Promise.reject('failed');
    }
  }

  getCurrentBrandID(): string {
    return this.currentBrandID;
  }

  getProducts(): Observable< {product: SMProductBasic, count: number}[] > {
    return this.oproducts;
  }

  deleteProduct(productID) {
    const next = this.products.value.filter(item => item.product.productID !== productID);
    this.products.next(next);
    this.updateCount();
  }

  getProductCount(): Observable<number> {
    return this.ocount;
  }

  updateCount() {
    if (this.products.value.length === 0) {
      this.currentBrandID = null;
    }
    this.count.next(this.products.value.length);
  }

  clearCart() {
    this.currentBrandID = null;
    this.products.next(null);
    this.count.next(0);
  }
}
